import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import AOS from 'aos'
import { SITE,ROUTES } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import Breadcrumb from '@common/Breadcrumb'
import Button from '@ui/Button'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.OUR_WORK)

/* ── Categories ── */
const CATEGORIES = [
  'All Works',
  'Government',
  'Healthcare',
  'Consulting',
  'Corporates',
  'Retail',
  'Education',
  'Non-Profit',
]

/* ── Project data ── */
const OUR_WORK = [
  { id: 1, title: 'GRID-INDIA', desc: 'Dummy text sssssssizen services portal streamlining 40+ government services into a single accessible platform.', tags: ['Industries', 'Domain'], image: '/assets/images/stories/grid.png', link: 'https://grid-india.in/', category: 'Government' },
  { id: 2, title: 'Numind Consultancy', desc: 'Web Design and Concept', tags: ['Industries', 'Domain'], image: '/assets/images/stories/numindconsultancy.jpg', link: 'https://numindconsultancy.com/', category: 'Education' },
  { id: 3, title: 'J.J. Academy', desc: 'Web Design and Concept', tags: ['Industries', 'Domain'], image: '/assets/images/stories/jj_academy.jpg', link: 'https://www.jjacademy.in/', category: 'Education' },
  { id: 4, title: 'National Ujala Dashboard', desc: 'Web Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/delp1.jpg', link: '#', category: 'Government' },
  { id: 5, title: 'Praapti App', desc: 'Web Development,Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/praapti.jpg', link: 'https://praapti.in/', category: 'Government' },
  { id: 6, title: 'Vidyut Pravah', desc: 'Web Development, Hosting,Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/posoco1.jpg', link: 'http://vidyutpravah.in/', category: 'Government' },
  { id: 7, title: 'MERIT', desc: 'Web Development,Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/merit.jpg', link: 'http://www.meritindia.in/', category: 'Government' },
  { id: 8, title: 'National AgDSM Dashboard', desc: 'Web Development, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/agdsm1.jpg', link: 'https://www.agdsm.in/', category: 'Government' },
  { id: 9, title: 'TipStop', desc: 'Web Design and Concept, Content Writing', tags: ['Industries', 'Domain'], image: '/assets/images/stories/tipstop.jpg', link: '#', category: 'Corporates' },
  { id: 10, title: 'Change Works India', desc: 'Web Design and Concept', tags: ['Industries', 'Domain'], image: '/assets/images/stories/changes_works_india.jpg', link: 'https://www.changeworksindia.com/', category: 'Consulting' },
  { id: 11, title: 'Mediangels', desc: 'Web Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/mediangels_new.jpg', link: '#', category: 'Healthcare' },
  { id: 12, title: 'Sterling Electro Enterprises Pvt. Ltd.', desc: 'Web Design and Concept, Content Writing', tags: ['Industries', 'Domain'], image: '/assets/images/stories/sterling_electro.jpg', link: 'https://www.sterlingelectro.com/', category: 'Corporates' },
  { id: 13, title: 'Biguine', desc: 'Web Maintenance, SEO', tags: ['Industries', 'Domain'], image: '/assets/images/stories/biguine.jpg', link: 'https://biguineindia.co.in/', category: 'Retail' },
  { id: 14, title: 'IIT Som Mbp', desc: 'Web Design', tags: ['Industries', 'Domain'], image: '/assets/images/stories/iit_som_mbp.jpg', link: '#', category: 'Education' },
  { id: 15, title: 'SNEHA', desc: 'Web Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/sneha.jpg', link: 'https://www.snehamumbai.org/', category: 'Non-Profit' },
  { id: 16, title: 'Qualilife Neurosciences', desc: 'Web Design', tags: ['Industries', 'Domain'], image: '/assets/images/stories/qualilife_neurosciences.jpg', link: 'https://qualilifeneurosciences.com/', category: 'Healthcare' },
  { id: 17, title: 'Eureka Techno Service', desc: 'Web Design and Concept, Content Writing', tags: ['Industries', 'Domain'], image: '/assets/images/stories/eureka_techno_service.jpg', link: '#', category: 'Corporates' },
  { id: 18, title: 'Rudi - Dash Two', desc: 'Responsive Web Design, Web Development, App Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/rudi_dashtwo.jpg', link: 'https://rudi.dashtwo.com/login?returnUrl=%2F', category: 'Consulting' },
  { id: 19, title: 'Remson', desc: 'Web Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/remson.jpg', link: 'http://www.remson.in/index.aspx', category: 'Retail' },
  { id: 20, title: 'Tapin', desc: 'Web Design and Concept', tags: ['Industries', 'Domain'], image: '/assets/images/stories/tapin.jpg', link: '#', category: 'Non-Profit' },
  { id: 21, title: 'Amar Ayurved', desc: 'Web Design', tags: ['Industries', 'Domain'], image: '/assets/images/stories/amar_ayurved.jpg', link: 'https://www.amarayurved.com/', category: 'Healthcare' },
  { id: 22, title: 'Flyt', desc: 'Responsive Web Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/flyt.jpg', link: '#', category: 'Consulting' },
  { id: 23, title: 'Make My Returns', desc: 'Responsive Web Design, Web Development, App Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/make_my_returns.jpg', link: '#', category: 'Corporates' },
  { id: 24, title: 'Shaze', desc: 'Web Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/shaze_layout.jpg', link: '#', category: 'Retail' },
  { id: 25, title: 'Vidyalankar', desc: 'Responsive Web App Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/vidyalankar.jpg', link: '#', category: 'Education' },
  { id: 26, title: 'Discover Urjaa', desc: 'Technical Support', tags: ['Industries', 'Domain'], image: '/assets/images/stories/discover_urjaa.jpg', link: 'http://www.discoverurjaa.com/', category: 'Non-Profit' },
  { id: 27, title: 'Dr. Ashwini Naik (Physiotherapist)', desc: 'Web Design', tags: ['Industries', 'Domain'], image: '/assets/images/stories/physio_mumbai.jpg', link: '#', category: 'Healthcare' },
  { id: 28, title: 'Resonate', desc: 'Web Design and Concept, Brochures', tags: ['Industries', 'Domain'], image: '/assets/images/stories/resonate_consulting.jpg', link: 'http://www.resonateconsulting.in/', category: 'Consulting' },
  { id: 29, title: 'Infinity FinVest Solutions Pvt. Ltd.', desc: 'Web Design and Concept', tags: ['Industries', 'Domain'], image: '/assets/images/stories/infinity_group_global.jpg', link: '#', category: 'Corporates' },
  { id: 30, title: 'Moglys', desc: 'Brochures', tags: ['Industries', 'Domain'], image: '/assets/images/stories/moglys.jpg', link: '#', category: 'Education' },
  { id: 31, title: 'Dr. Ian DSouza', desc: 'Web Design', tags: ['Industries', 'Domain'], image: '/assets/images/stories/dr_ian_dsouza.jpg', link: '#', category: 'Healthcare' },
  { id: 32, title: 'Clear Maze', desc: 'Web Design and Concept', tags: ['Industries', 'Domain'], image: '/assets/images/stories/clear_maze.jpg', link: 'https://clearmaze.co.in/', category: 'Consulting' },
  { id: 33, title: 'India Exports', desc: 'Web Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/india_exports.jpg', link: 'http://www.indiaexports.net/', category: 'Corporates' },
  { id: 34, title: 'Anupriya Desai (Astrologer and Vaastu Consultant)', desc: 'Web Design and Concept', tags: ['Industries', 'Domain'], image: '/assets/images/stories/astrologer_and-vaastu_consultant.jpg', link: '#', category: 'sRetail' },
  { id: 35, title: 'Ranka Academy', desc: 'Web Design', tags: ['Industries', 'Domain'], image: '/assets/images/stories/ranka_academy.jpg', link: '#', category: 'Education' },
  { id: 36, title: 'Qualilife Diagnostics', desc: 'Web Design', tags: ['Industries', 'Domain'], image: '/assets/images/stories/qualilife_diagnostics.jpg', link: 'https://qualilifediagnostics.com/', category: 'Healthcare' },
  { id: 37, title: 'Space Xperts', desc: 'Web Design and Concept, Content Writing', tags: ['Industries', 'Domain'], image: '/assets/images/stories/space_xperts.jpg', link: '#', category: 'Corporates' },
  { id: 38, title: 'Aabhushan Jewellers', desc: 'Web Design, In-house Software', tags: ['Industries', 'Domain'], image: '/assets/images/stories/aabhushan_jewellers.jpg', link: 'http://www.aabhushanjewellers.com/', category: 'Retail' },
  { id: 39, title: 'Atiitya', desc: 'Web Design, Web Tools,  Maintenance, Brochures, Corporate Presentations', tags: ['Industries', 'Domain'], image: '/assets/images/stories/atiitya.jpg', link: 'https://atiitya.com/', category: 'Consulting' },
  { id: 40, title: 'Onella', desc: 'Web Design', tags: ['Industries', 'Domain'], image: '/assets/images/stories/onella_layout.jpg', link: '#', category: 'Corporates' },
  { id: 41, title: 'Crocus Saffron', desc: 'Web Design and Concept', tags: ['Industries', 'Domain'], image: '/assets/images/stories/crocus_saffron.jpg', link: '#', category: 'Retail' },
  { id: 42, title: 'Perks Hospitality and Facility Management Services', desc: 'Web Development, Hosting, Technical Support and Maintenance', tags: ['Industries', 'Domain'], image: '/assets/images/stories/perks_hospitality.jpg', link: '#', category: 'Corporates' },
  { id: 43, title: 'Gold Valuer', desc: 'Web Design', tags: ['Industries', 'Domain'], image: '/assets/images/stories/gold_valuer.jpg', link: 'http://www.goldvaluer.in/government-approved-jewellery-valuer-in-mumbai.html', category: 'Retail' },
  { id: 44, title: 'Miara', desc: 'Web Support', tags: ['Industries', 'Domain'], image: '/assets/images/stories/miara.jpg', link: '#', category: 'Retail' },
]

function useFlipAnimation(items) {
  const gridRef = useRef(null)
  const positionCacheRef = useRef(new Map())
  const animationFrameRef = useRef(null)
  const hasMountedRef = useRef(false)

  const recordPositions = () => {
    if (!gridRef.current) return

    const cards = gridRef.current.querySelectorAll('[data-flip-id]')

    cards.forEach(card => {
      positionCacheRef.current.set(
        card.dataset.flipId,
        card.getBoundingClientRect()
      )
    })
  }

  useLayoutEffect(() => {
    if (!gridRef.current) return

    const cards = gridRef.current.querySelectorAll('[data-flip-id]')

    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current)
    }

    if (!hasMountedRef.current) {
      hasMountedRef.current = true

      cards.forEach(card => {
        card.style.transform = ''
        card.style.opacity = ''
        card.style.transition = ''

        positionCacheRef.current.set(
          card.dataset.flipId,
          card.getBoundingClientRect()
        )
      })

      return
    }

    cards.forEach(card => {
      const id = card.dataset.flipId
      const previous = positionCacheRef.current.get(id)
      const current = card.getBoundingClientRect()

      if (!previous) {
        card.style.transition = 'none'
        card.style.opacity = '0'
        card.style.transform = 'scale(0.92)'

        animationFrameRef.current = requestAnimationFrame(() => {
          card.style.transition =
            'transform 820ms cubic-bezier(0.4, 0, 0.2, 1), opacity 420ms ease'

          card.style.transform = 'scale(1)'
          card.style.opacity = '1'
        })

        return
      }

      const deltaX = previous.left - current.left
      const deltaY = previous.top - current.top

      if (
        Math.abs(deltaX) < 1 &&
        Math.abs(deltaY) < 1
      ) {
        card.style.transform = ''
        card.style.opacity = ''
        card.style.transition = ''
        return
      }

      card.style.transition = 'none'
      card.style.transform =
        `translate3d(${deltaX}px, ${deltaY}px, 0)`

      animationFrameRef.current = requestAnimationFrame(() => {
        animationFrameRef.current = requestAnimationFrame(() => {
          card.style.transition =
            'transform 820ms cubic-bezier(0.4, 0, 0.2, 1)'

          card.style.transform =
            'translate3d(0, 0, 0)'
        })
      })
    })

    cards.forEach(card => {
      positionCacheRef.current.set(
        card.dataset.flipId,
        card.getBoundingClientRect()
      )
    })

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current)
      }
    }
  }, [items])

  return {
    gridRef,
    recordPositions,
  }
}

/* ═══════════════════════════════════════════════════════════════════════
   Our Work Page
   ═══════════════════════════════════════════════════════════════════════ */

export default function OurWork() {
  //document.title = `Our Work | ${SITE.fullName}`
  

  useEffect(() => {
    AOS.refresh()
    window.scrollTo(0, 0)
  }, [])

  const [activeCategory, setActiveCategory] =
    useState('All Works')

  const {
    gridRef,
    recordPositions,
  } = useFlipAnimation(activeCategory)

  /* Category tab click */
  const handleTabClick = (cat) => {
    if (cat === activeCategory) return

    recordPositions()
    setActiveCategory(cat)
  }

  /* Filter projects */
  const currentFiltered =
    activeCategory === 'All Works'
      ? OUR_WORK
      : OUR_WORK.filter(
          item => item.category === activeCategory
        )

  return ( <>
      {/* <MetaInfo
        title={`Our Work | ${SITE.fullName}`}
        description="Explore CruxBytes projects across government, healthcare, consulting, retail and education: web, mobile and enterprise software delivered for clients."
      /> */}
       <MetaInfo
      title={`${label} ${SITE.metaTagPostText}`} 
      description={metaDesc}
      keywords=""
      />
    <main
      id="main-content"
      className="page-wrapper ourwork-page"
    >
      {/* Hero */}
      <div className="page-hero page-hero-small">
        <div
          className="bg-grid bg-grid--fill"
          aria-hidden="true"
        />

        <div className="container">
          {/* <div className="section-label section-label-small">
            - Our Work -
          </div> */}
          <Breadcrumb />

          <h1 data-aos="fade-up" data-aos-delay={100} >
            {/* Our Work */}
            {label}
          </h1>

          <p className="page-subtitle page-subtitle-small" data-aos="fade-up" data-aos-delay={200}>
           {/* Projects we are proud of — from government portals to enterprise platforms. Real Projects, real work. */}
           {pageDesc}
           </p>
           <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
              Book your free consultation
            </Button>
        </div>
      </div>

      {/* Category Tabs */}
      <header
        className="ourwork-toolbar"
        role="banner"
      >
        <div className="container">
          <div
            className="ourwork-tabs"
            role="tablist"
            aria-label="Filter projects by category"
          >
            {CATEGORIES.map((cat,i) => (
              <button
                key={cat}
                type="button"
                role="tab"
                aria-selected={activeCategory === cat}
                className={`ourwork-tab${
                  activeCategory === cat
                    ? ' ourwork-tab--active'
                    : ''
                }`}
                onClick={() => handleTabClick(cat)}
                data-aos="fade-up" data-aos-delay={i * 100}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </header>

      {/* Project Grid */}
      <section
        className="ourwork-grid-section section-py"
        aria-label="Our projects"
      >
        <div className="container">
          {currentFiltered.length > 0 ? (
            <div
              className="ourwork-grid"
              ref={gridRef}
              
            >
              {currentFiltered.map((item,i) => {
                const isExternal =
                  item.link &&
                  item.link !== '#'

                return (
                  <a
                    key={item.id}
                    data-flip-id={String(item.id)}
                    href={item.link}
                    className="ourwork-card"
                    data-aos="fade-left" data-aos-delay={i * 80}
                    target={
                      isExternal
                        ? '_blank'
                        : undefined
                    }
                    rel={
                      isExternal
                        ? 'noopener noreferrer'
                        : undefined
                    }
                  >
                    <div className="ourwork-card-media">
                      <img
                        src={item.image}
                        alt={item.title}
                        loading="lazy"
                        width="600"
                        height="360"
                      />
                    </div>

                    <div className="ourwork-card-overlay">
                      <div className="ourwork-card-overlay-inner">
                        <div className="ourwork-card-title-wrap">
                          <h3 className="ourwork-card-title">
                            {item.title}
                          </h3>
                        </div>

                        <p className="ourwork-card-desc">
                          {item.desc}
                        </p>

                        {item.tags?.length > 0 && (
                          <div
                            className="ourwork-card-tags"
                            aria-label="Tags"
                          >
                            {item.tags.map(tag => (
                              <span
                                key={tag}
                                className="ourwork-card-tag"
                              >
                                {tag}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </a>
                )
              })}
            </div>
          ) : (
            <p className="ourwork-empty">
              No projects found in this category yet.
            </p>
          )}
        </div>
      </section>

      {/* Transform Banner */}
      <TransformBanner />
    </main>
    </>
  )
}